import React from 'react';
import { withStyles } from 'tss-react/mui';

import RelatedRecordsButton from '@components/RelatedRecordsTable/RelatedRecordsButton';

function CustomToolbar() {
  return (
    <React.Fragment>
      <RelatedRecordsButton />
    </React.Fragment>
  );
}

export default withStyles(
  CustomToolbar,
  { root: {} },
  {
    name: 'CustomToolbar',
  }
);
